/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Expand = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8" }],
    ["path", { d: "M3 16.2V21m0 0h4.8M3 21l6-6" }],
    ["path", { d: "M21 7.8V3m0 0h-4.8M21 3l-6 6" }],
    ["path", { d: "M3 7.8V3m0 0h4.8M3 3l6 6" }]
  ]
];

export { Expand as default };
//# sourceMappingURL=expand.js.map
